import { RowCenter } from 'layout/Components/Row'
import styled from 'styled-components'
import Image from 'UIKit/Image'
import TransText from 'UIKit/Text/TransText'
import { CardSection, CardTitle } from 'views/Tournament'

export const ProviderTournamentLeaderBoard = () => {
  return (
    <CardSection>
      <CardTitle marginRight="12px">Leaderboard</CardTitle>
      <RowCenter mt="8px">
        <StyledGoldTrophy src="/images/tournament/gold-trophy.png" width={64} height={64} alt="gold trophy" />
        <TransText fontSize="14px" fontWeight={500} lineHeight="normal" color="textAlt5" ml="16px">
          The leaderboard is located inside each Eligible Game in this tournament.
        </TransText>
      </RowCenter>
    </CardSection>
  )
}

const StyledGoldTrophy = styled(Image)`
  min-width: 64px;
  min-height: 64px;
`
